import { render, staticRenderFns } from "./RevampedFeedback.vue?vue&type=template&id=7b27d266&scoped=true&"
import script from "./RevampedFeedback.vue?vue&type=script&lang=js&"
export * from "./RevampedFeedback.vue?vue&type=script&lang=js&"
import style0 from "./RevampedFeedback.vue?vue&type=style&index=0&id=7b27d266&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b27d266",
  null
  
)

export default component.exports